import { actionPlanReview } from 'legacy/lut/features/partner360/commitment'
import {
  selectFinancialYear,
  selectPartnerId,
  selectProgramType,
} from 'legacy/lut/features/partner360/configuration'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback, useState } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'
import { Flex } from 'core-components/library/flex'
import { LoaderOverlay } from 'core-components/library/loader'
import { TRANSLATION_KEYS } from 'partner360/components/commitmentReminder/components/planReviewConfirmation/components/planReviewConfirmationContent/translations'

import styles from './PlanReviewConfirmationContent.module.scss'

interface IPlanReviewConfirmationContentProps {
  onClose: () => void
}

export const PlanReviewConfirmationContent = ({ onClose }: IPlanReviewConfirmationContentProps) => {
  const fYear = useSelector(selectFinancialYear)
  const programType = useSelector(selectProgramType)
  const partnerId = useSelector(selectPartnerId)

  const [isSuccess, setIsSuccess] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const dispatch = useAppDispatch()

  const onPlanReview = useCallback(async () => {
    setIsLoading(true)
    await dispatch(actionPlanReview({ partnerId, programType, fYear })).unwrap()
    setIsLoading(false)
    setIsSuccess(true)
  }, [dispatch, fYear, partnerId, programType])

  if (isSuccess) {
    return (
      <Flex
        gap={'xl'}
        className={styles.root}
        flexDirection={'column'}
        justifyContent={'space-between'}
      >
        <Flex gap={'md'} flexDirection={'column'}>
          <h5 className={styles.title}>
            <Translation text={TRANSLATION_KEYS.successMsgTitle} span />
          </h5>

          <Translation text={TRANSLATION_KEYS.successMsg} span />
        </Flex>
        <Flex justifyContent={'flex-end'} alignItems={'center'} gap={'md'}>
          <Button onClick={onClose}>
            <Translation text={TRANSLATION_KEYS.successMsgOk} />
          </Button>
        </Flex>
      </Flex>
    )
  }

  return (
    <Flex
      gap={'xl'}
      className={styles.root}
      flexDirection={'column'}
      justifyContent={'space-between'}
    >
      <LoaderOverlay show={isLoading} />
      <Flex gap={'md'} flexDirection={'column'}>
        <h5 className={styles.title}>
          <Translation text={TRANSLATION_KEYS.confirmMsgTitle} span />
        </h5>

        <Translation text={TRANSLATION_KEYS.confirmMsg} span />
      </Flex>
      <Flex justifyContent={'flex-end'} alignItems={'center'} gap={'md'}>
        <Button onClick={onPlanReview}>
          <Translation text={TRANSLATION_KEYS.confirmMsgOk} />
        </Button>

        <Button color={'danger'} onClick={onClose}>
          <Translation text={TRANSLATION_KEYS.confirmMsgCancel} />
        </Button>
      </Flex>
    </Flex>
  )
}
